export const TABLE_ERROR_MESSAGES = {
  NO_RESULTS_TITLE: 'No results found.',
  NO_RESULTS_SUB_TEXT:
    'No results found. Try refining your search or adjusting the filters.',
};

export const TASK_LIST_ERROR_MESSAGES = {
  UNABLE_TO_FETCH_TASKS: 'Unable to fetch tasks',
  UNABLE_TO_LOAD_USERS: 'Unable to load users',
  TASK_DELETED_SUCCESSFULLY: 'Task deleted successfully',
  UNABLE_TO_DELETE_TASK: 'Unable to delete task',
  TASK_UPDATED_SUCCESSFULLY: 'Task updated successfully',
  UNABLE_TO_UPDATE_TASK: 'Unable to update task',
};

export const TASKS_FORM_FIELDS_ERROR_MESSAGES = {
  name: {
    required: 'Task Name is required',
    pattern: 'Task Name is Invalid',
  },
  linkTaskTo: {
    required: 'Contact is required',
  },
  status: {
    required: 'Status is required',
  },
  priority: {
    required: 'Priority is required',
  },
  deadLine: {
    required: 'Due Date is required',
  },
};

export const NOTE_MESSAGES = {
  NOTE_DELETED_SUCCESSFULLY: 'Note deleted successfully',
  UNABLE_TO_DELETE_NOTE: 'Unable to delete note',
};
